import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { IWarehouseTypes } from '@/entity/warehouse/Type/Warehouse.type.types';

@Module({
    namespaced: true,
    name: 'StoresTypes',
    store,
    dynamic: true
})

class StoresTypesModule extends VuexModule implements IStoreReady {
    //storesTypes: IStoreTypes | null = null;
    storesTypes: IWarehouseTypes[] | null = null
    Loaded = false
    ready = false

    @MutationAction
    async fetchAll(): Promise<{ storesTypes: IWarehouseTypes[]; Loaded: boolean }> {
        const storesTypes = await store.$repository.warehouseTypes.fetchAll();
        let Loaded = false;
        if (storesTypes) {
            Loaded = true;
        }
        return { storesTypes, Loaded };
    }
}
export const StoresTypes = getModule(StoresTypesModule);
